import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

export interface Breadcrumb {
  label: string;
  url: string;
}

// @Injectable({ providedIn: 'root' })
// export class BreadcrumbService {

//   private _breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
//   breadcrumbs$ = this._breadcrumbs.asObservable();
//   private _pageTitle = new BehaviorSubject<string>('Dashboard');
//   pageTitle$ = this._pageTitle.asObservable();
//   constructor(private router: Router, private route: ActivatedRoute) {
//     this.router.events
//       .pipe(filter(event => event instanceof NavigationEnd))
//       .subscribe(() => {
//         const breadcrumbs = this.buildBreadCrumb(this.route.root);
//         this._breadcrumbs.next(breadcrumbs);

//         if (breadcrumbs.length > 0) {
//           const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
//           this._pageTitle.next(lastBreadcrumb.label);
//         } else {
//           this._pageTitle.next('');
//         }
//       });
//   }

//   private buildBreadCrumb(
//     route: ActivatedRoute,
//     url: string = '',
//     breadcrumbs: Breadcrumb[] = []
//   ): Breadcrumb[] {  

//     const children = route.children;

//     if (children.length === 0) {
//       return breadcrumbs;
//     }

//     for (const child of children) {

//       const routeURL = child.snapshot.url
//         .map(segment => segment.path)
//         .join('/');

//       if (routeURL) {
//         url += `/${routeURL}`;
//       }

//       const label = child.snapshot.data['breadcrumb'];

//       if (label) {
//         breadcrumbs.push({
//           label: label,
//           url: url
//         });
//       }

//       return this.buildBreadCrumb(child, url, breadcrumbs);
//     }

//     return breadcrumbs;
//   }
// }

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {

  private _breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this._breadcrumbs.asObservable();

  private _pageTitle = new BehaviorSubject<string>('Dashboard');
  pageTitle$ = this._pageTitle.asObservable();

  private _contextLabel = new BehaviorSubject<string>('');

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumbs();
      });
  }

  // setContext(label: string) {
  //   this._contextLabel.next(label);
  //   this.updateBreadcrumbs();
  // }
  setContext(label: string) {
    this._contextLabel.next(label);

    setTimeout(() => {
      this.updateBreadcrumbs();
    });
  }

  clearContext() {
    this._contextLabel.next('');
    // this.updateBreadcrumbs();
  }

  private updateBreadcrumbs() {

    let breadcrumbs = this.buildBreadCrumb(this.route.root);

    const context = this._contextLabel.value;

    if (context) {
      breadcrumbs.push({
        label: context,
        url: ''
      });
    }

    this._breadcrumbs.next(breadcrumbs);

    if (breadcrumbs.length > 0) {
      this._pageTitle.next(
        breadcrumbs[breadcrumbs.length - 1].label
      );
    }
  }

  private buildBreadCrumb(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {

    const children = route.children;

    if (!children.length) {
      return breadcrumbs;
    }

    for (const child of children) {

      const routeURL = child.snapshot.url
        .map(segment => segment.path)
        .join('/');

      if (routeURL) {
        url += `/${routeURL}`;
      }

      const label = child.snapshot.data['breadcrumb'];

      if (label) {
        breadcrumbs.push({
          label,
          url
        });
      }

      return this.buildBreadCrumb(
        child,
        url,
        breadcrumbs
      );
    }

    return breadcrumbs;
  }
}